// No trailing slashes!
const URL_PREFIX = "https://brainhub.com.ph";
export const PUBLIC_COLPUNO_API_BASE_URL = "https://backend.colpuno.com/api";
export const PUBLIC_COLPUNO_USER_INVITATIONS_URL = `${PUBLIC_COLPUNO_API_BASE_URL}/user_invitations`;

export default {
  title: "Brainhub",
  localPrefix: 'bhub',
  // NB: URL prefixes below must not end with a slash!
  baseURL: `${URL_PREFIX}/api`,
  storageURL: `${URL_PREFIX}/storage`,
  PUBLIC_COLPUNO_API_BASE_URL,
  PUBLIC_COLPUNO_USER_INVITATIONS_URL,
};
